<div class="tire-shipping-recalculate-dialog">
  <div class="tire-shipping-recalculate-dialog-header flex-between-center">
    <div class="flex-start-start">
      <img src="../../../../../../../assets/img/exclamation.png" alt="exclamation" class="mr-2">

      <div class="flex-column">
        <p class="m-0 font-bold font-16">Recalculate estimated shipping</p>
        <p class="m-0 font-gray-400 w-75">Partial ordering can affect the estimated shipping. kindly review the updated
          costs below</p>
      </div>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="tire-shipping-recalculate-dialog-body">
    <div *ngFor="let store of stores" class="tsr-store">
      <p class="tsr-store-name">{{store?.header}}</p>

      <div *ngFor="let part of store?.parts" class="tsr-entry p-2">
        <p class="m-0 font-600">{{part?.description}}</p>
        <div class="flex-start-center">
          <p class="m-0 mr-2 text-right font-10">
            Qty
            <span class="font-600 d-block font-14">{{part?.quantity}}</span>
          </p>

          <p class="m-0 text-right font-10">
            Total cost
            <span class="font-600 d-block font-14">{{part?.totalCost || 0 | currency: usd}}</span>
          </p>
        </div>
      </div>

      <div class="tsr-store-footer p-2">
        <div class="tsr-entry">
          <p class="m-0">Previous estimated shipping</p>
          <p class="m-0">{{store?.previousShippingCost || 0 | currency: usd}}</p>
        </div>
        <div class="tsr-entry pt-2">
          <p class="m-0 font-600">Updated estimated shipping</p>
          <p class="m-0 font-primary font-700">
            <span *ngIf="!isShippingCostLoading">{{store?.shippingCost || 0 | currency: usd}}</span>
            <i *ngIf="isShippingCostLoading"class="fal fa-spinner rotate"></i>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="tire-shipping-recalculate-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-2" (click)="handleClose()">Cancel</button>
    <button class="btn btn-primary btn-submit" [disabled]="isShippingCostLoading" (click)="handleSubmit()">
      Confirm and place order
    </button>
  </div>
</div>
